import {formatInteger} from "@/lib/utils";
import {LabelValue} from "@/lib/components/LabelValueList";

/**
 * Generates a field object for an integer value with optional formatting and tooltip.
 *
 * @param {number | undefined} numberValue - The integer value to be displayed. If undefined, a default "not available" message is used.
 * @param {string} label - The label for the field.
 * @param {string} [defaultValue=""] - The default value.
 * @param {string} [locale] - The locale to use for formatting the integer.
 * @param {string} [tooltipKey] - The key for the tooltip text.
 * @returns {LabelValue} The field object with label, value, and tooltipKey properties.
 */
export const integerField = (
    numberValue: number | undefined,
    label: string,
    defaultValue: string = "",
    locale?: string,
    tooltipKey?: string
): LabelValue => ({
    label,
    value: numberValue ? (formatInteger(numberValue, locale) ?? "") : defaultValue,
    tooltipKey
});
